module.exports = __webpack_public_path__ + "img/LossTitle.9c235012.png";